import React from 'react';
import { useTranslation } from 'next-i18next';
import FilterDropdown, { DARK_THEME, FilterDropdownTheme } from 'components/search-bar/advanced-search/filter-dropdown';
import FilterDropdownPropertyType from 'components/search-bar/advanced-search/filter-dropdown/home-type';
import { searchFilterIds } from 'constants/test-constants';
import { PropertyTypeOption } from 'utils/select-options';
import { getLocalizedPropertyTypeOptions } from 'utils/localized-select-options';
import HomeIcon from 'components/icon/filters/home-icon';
import { Namespaces } from 'types/locales';

import type { PropertyTypeFilter } from 'contexts/preferences/listing-params/types';

//#region Types
export interface HomeTypeFilterDropdownProps {
  propertyType: PropertyTypeFilter;
  propertyTypeFilterLabel: string;
  propertyTypeList?: PropertyTypeOption[];
  theme?: FilterDropdownTheme;
  onValueChange(value: PropertyTypeFilter): void;
}
//#endregion

const PropertyTypeFilterDropdown = ({ propertyType, propertyTypeFilterLabel, onValueChange, theme = DARK_THEME }: HomeTypeFilterDropdownProps) => {
  const { t } = useTranslation(Namespaces.SEARCH);
  const isDefaultValue = Object.keys(propertyType).filter(key => propertyType[key]).length === 6;
  
  // Create internationalized property type list with ALL property types
  const i18nPropertyTypeList = getLocalizedPropertyTypeOptions(t);
  
  return (
    <FilterDropdown
      theme={theme}
      label={propertyTypeFilterLabel}
      testId={searchFilterIds.homeTypeDropdownMap}
      icon={<HomeIcon />}
      isDefaultValue={isDefaultValue}
    >
      <FilterDropdownPropertyType
        currentHomeTypeFilter={propertyType}
        onValueChange={onValueChange}
        propertyTypeList={i18nPropertyTypeList}
      />
    </FilterDropdown>
  );
};

export default PropertyTypeFilterDropdown;